/* ─────────────────────────────────────────────────────────────────
   Printale — Product Page Enhancements
   - Injects trust signals bar ABOVE buy button (above fold)
   - Injects "Now Showing" kicker above product title
   ───────────────────────────────────────────────────────────────── */

const TRUST_HTML = `
  <span class="printale-trust-bar__item"><span aria-hidden="true">✦</span> Made from scratch</span>
  <span class="printale-trust-bar__item"><span aria-hidden="true">✉</span> Proof before print</span>
  <span class="printale-trust-bar__item"><span aria-hidden="true">🌍</span> Ships worldwide</span>
  <span class="printale-trust-bar__item"><span aria-hidden="true">♥</span> Quality guarantee</span>
`;

function buildTrustBar() {
  const bar = document.createElement('div');
  bar.className = 'printale-trust-bar';
  bar.setAttribute('aria-label', 'Why Printale');
  bar.innerHTML = TRUST_HTML;
  return bar;
}

function injectTrustBar() {
  const observer = new MutationObserver(() => {
    const buyButtons = document.querySelector(
      'buy-buttons, [data-type="buy-buttons"], .product-form__buttons, form[action*="/cart/add"]'
    );
    if (!buyButtons || document.querySelector('.printale-trust-bar')) return;
    buyButtons.insertAdjacentElement('beforebegin', buildTrustBar());
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also try immediately
  setTimeout(() => {
    const buyButtons = document.querySelector(
      'buy-buttons, [data-type="buy-buttons"], .product-form__buttons, form[action*="/cart/add"]'
    );
    if (buyButtons && !document.querySelector('.printale-trust-bar')) {
      buyButtons.insertAdjacentElement('beforebegin', buildTrustBar());
    }
  }, 800);
}

function injectKicker() {
  setTimeout(() => {
    const title = document.querySelector(
      '[data-template="product"] h1, [data-template="product"] product-title'
    );
    if (!title || document.querySelector('.printale-product-kicker')) return;
    const kicker = document.createElement('p');
    kicker.className = 'printale-product-kicker';
    kicker.textContent = '✦ Now Showing — Custom Movie Poster';
    title.insertAdjacentElement('beforebegin', kicker);
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    injectTrustBar();
    injectKicker();
  });
} else {
  injectTrustBar();
  injectKicker();
}
